import { render, staticRenderFns } from "./ReturnApp.vue?vue&type=template&id=2ad9594a&scoped=true&"
import script from "./ReturnApp.vue?vue&type=script&lang=js&"
export * from "./ReturnApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9594a",
  null
  
)

export default component.exports